/* global createCookie readCookie */ // Defined in general.js
/* global userId userHash */ // defined in userInfo.js
/* global Uri */ // defined in URI.js

/**
 * Initializes a user's favorites based on their login data and cookies
 * @param loadFavoritesCallbackName Name of callback to load favorites once they're initialized
 */
export function setup(loadFavoritesCallbackName) {
    if (readCookie('userId') != null || readCookie('favCookiesSet') != null) {
        const callback = typeof loadFavoritesCallbackName === 'function'
            ? loadFavoritesCallbackName
            : window[loadFavoritesCallbackName];

        $(document).ready(callback);
        $(document).on('updateFavoritesStorage', callback);

        return () => $(document).on('updateFavoritesStorage', callback);
    }
}

/**
 * Loads a user's favorite searches, teachers, schools, etc.
 * Designed for use as search filters
 * @param existingSearches List of any saved searches that have already been loaded (for when you're requesting more)
 * @param callback To process the returned favorites data
 */
export function load(existingSearches, callback) {
    let followDate = readCookie('followDate');

    if (followDate == null) {
        followDate = (new Date()).getTime();
        createCookie('followDate', followDate, 0);
    }

    if (readCookie('userId') != null) {
        let favoritesURL = new Uri('/common/follow_list.html')
            .replaceQueryParam('ver', followDate)
            .replaceQueryParam('userId', userId)
            .replaceQueryParam('userHash', userHash);

        if (existingSearches) {
            const donorMMIIds = existingSearches.map(search => search.donorMMIId).join(',');
            favoritesURL = favoritesURL.replaceQueryParam('donorMMIIds', donorMMIIds);
        }

        $.getJSON(favoritesURL.toString(), callback);
    } else {
        callback();
    }
}
